import { Quote } from "lucide-react";

interface UseCaseTestimonialProps {
  quote: string;
  name: string;
  role: string;
  city: string;
  initials: string;
  accentColor: string;
}

const UseCaseTestimonial = ({
  quote,
  name,
  role,
  city,
  initials,
  accentColor,
}: UseCaseTestimonialProps) => {
  return (
    <section className="relative py-20 lg:py-24 bg-[#0A0A0F]">
      {/* Accent glow */}
      <div className="absolute inset-0">
        <div
          className="absolute top-1/2 left-1/4 w-[400px] h-[400px] rounded-full blur-[150px] opacity-15"
          style={{ backgroundColor: accentColor }}
        />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          {/* Testimonial card */}
          <div className="relative rounded-3xl p-[1px] bg-gradient-to-b from-white/[0.15] to-transparent animate-fade-up">
            <div className="rounded-3xl bg-[#0F0F14]/90 backdrop-blur-xl p-8 lg:p-12">
              {/* Quote icon */}
              <div
                className="h-12 w-12 rounded-xl flex items-center justify-center mb-6"
                style={{ backgroundColor: `${accentColor}20` }}
              >
                <Quote className="h-6 w-6" style={{ color: accentColor }} />
              </div>

              {/* Quote text */}
              <blockquote className="text-xl lg:text-2xl text-white/80 leading-relaxed mb-8">
                "{quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div
                  className="h-14 w-14 rounded-xl flex items-center justify-center text-lg font-bold text-white"
                  style={{ background: `linear-gradient(135deg, ${accentColor}, ${accentColor}80)` }}
                >
                  {initials}
                </div>
                <div>
                  <p className="text-white font-semibold">{name}</p>
                  <p className="text-white/50 text-sm">
                    {role} &middot; {city}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseTestimonial;
